// Background removed: Linear-inspired design uses darkness as space.
// The near-black #08090a canvas IS the whitespace.
export function SignInBackgroundArts() {
  return null;
}
